import React, { useLayoutEffect, useMemo, useRef, useState } from 'react';
import { buildMaintenancePageInnerHtml } from '../constants/maintenancePageWidget';

/**
 * Palco da página de manutenção. A largura segue a folha do curso,
 * sem esticar até a área cinza ao redor do palco.
 */
export default function RenderSiteMaintenance({ content = {}, widgetId }) {
  const slotRef = useRef(null);
  const [bleed, setBleed] = useState(null);
  const contentKey = JSON.stringify(content || {});
  const html = useMemo(
    () => buildMaintenancePageInnerHtml(content, widgetId, { stage: true }),
    [contentKey, widgetId]
  );

  useLayoutEffect(() => {
    const slot = slotRef.current;
    const host = slot?.parentElement;
    const canvas = slot?.closest('.course-wrapper');
    if (!host || !canvas) return undefined;
    const measure = () => {
      const hostBox = host.getBoundingClientRect();
      const canvasBox = canvas.getBoundingClientRect();
      const width = Math.round(canvasBox.width);
      const marginLeft = Math.round(canvasBox.left - hostBox.left);
      setBleed((prev) => {
        if (prev && Math.abs(prev.width - width) < 2 && Math.abs(prev.marginLeft - marginLeft) < 2) return prev;
        return { width, marginLeft };
      });
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(canvas);
    window.addEventListener('resize', measure);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, []);

  return (
    <div
      ref={slotRef}
      style={bleed ? { width: bleed.width, marginLeft: bleed.marginLeft, maxWidth: 'none' } : undefined}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
